import { LoanOfferItem } from '@shared/sec-loans'

import { LoanOfferWizardData } from './wizard/types'
import { WizardContext, WizardStep } from './wizard/wizardMachine'

export enum QueryParams {
  LoanOfferId = 'loanOfferId',
}

export interface FormContextValue extends WizardContext {
  step: WizardStep
  proceed: (formData?: Partial<LoanOfferWizardData>) => void
  openErrorModal: (requestId?: string) => void
  goBack: () => void
  goBackToStatus: () => void
  exit: () => Promise<void>
  exitWithConfirmDialog: () => void
}

export type ExistingLoanOfferContext = FormContextValue & Pick<Required<WizardContext>, 'loanOffer'>

export type OnAutomaticOfferData = {
  loanOffer: LoanOfferItem
}
